/**
 * @author AndréK
 * 07/03/2022
 */

//#region - BaseURL

//Development
//const baseURL = "https://localhost:5001/api";

//Produção
const baseURL = "http://projetonvi61.sgoas.nvi.com.br/api";

//Homologação
//const baseURL = "http://projetonvi52.sgoas.nvi.com.br/api";

const appointments = {
    baseURL
};

export default appointments;
